var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 121,
    viewBox: "0 0 126 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.822 51.9503C125.822 55.7179 124.109 59.2667 121.16 61.6072L62.9999 107.856L4.83968 61.6072C3.36499 60.437 2.20425 58.9623 1.40506 57.3163C0.605872 55.6608 0.177734 53.8341 0.177734 51.9503C0.177734 50.038 1.00547 48.1256 2.65142 46.8127L58.8993 1.93426C61.2968 0.0219124 64.7029 0.0219124 67.1005 1.93426L123.348 46.8127C124.994 48.1256 125.822 50.038 125.822 51.9503Z",
    fill: "url(#paint0_linear_378_4836)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.876 107.085H16.1235V16.5192C16.1235 14.35 17.8837 12.5898 20.0529 12.5898H105.947C108.116 12.5898 109.876 14.35 109.876 16.5192V107.085Z",
    fill: "url(#paint1_linear_378_4836)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.822 51.9492V108.378C125.822 115.066 120.389 120.499 113.701 120.499H12.2988C5.61033 120.499 0.177734 115.066 0.177734 108.378V51.9492C0.177734 53.8616 1.00547 55.7834 2.65142 57.0964L54.7321 98.6543L58.8993 101.975C61.2968 103.887 64.7029 103.887 67.1005 101.975L71.2677 98.6543L123.348 57.0964C124.994 55.7834 125.822 53.8616 125.822 51.9492Z",
    fill: "url(#paint2_linear_378_4836)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6976 52.4633V52.4918C88.6976 55.8979 88.2378 58.7807 87.3181 61.1402C86.3983 63.4997 85.1456 65.2852 83.56 66.4967C81.9679 67.7082 80.1697 68.3139 78.1654 68.3139C76.1992 68.3139 74.5595 67.7906 73.2466 66.7441C71.9273 65.7038 70.9759 64.4099 70.3923 62.8623L70.2401 62.4817H69.9547C69.2062 64.3845 68.0677 65.8022 66.5391 66.7345C65.0168 67.6606 63.263 68.1236 61.2777 68.1236C59.1022 68.1236 57.1993 67.5718 55.5692 66.4681C53.9455 65.3582 52.6769 63.801 51.7636 61.7967C50.8565 59.7924 50.403 57.4519 50.403 54.7752V54.7467C50.403 52.1778 50.8692 49.9166 51.8016 47.9631C52.7277 46.0095 54.0057 44.4777 55.6358 43.3677C57.2659 42.2641 59.137 41.7122 61.2492 41.7122C62.9364 41.7122 64.4809 42.1182 65.8826 42.9301C67.2844 43.7483 68.277 44.8456 68.8605 46.222H69.1079V42.3402H74.4358V57.3821C74.4358 59.4498 74.7974 60.9943 75.5205 62.0155C76.2372 63.0367 77.1823 63.5473 78.3557 63.5473C79.9033 63.5473 81.1497 62.6244 82.0948 60.7787C83.0462 58.9266 83.5219 56.196 83.5219 52.5869V52.5489C83.5219 48.5403 82.6751 45.0803 80.9816 42.1689C79.2944 39.2512 76.9191 36.9995 73.8555 35.4138C70.7983 33.8282 67.2209 33.0321 63.1235 33.0258C60.117 33.0321 57.3547 33.5554 54.8366 34.5956C52.3186 35.6422 50.1366 37.1327 48.2909 39.0673C46.4388 40.9955 45.0053 43.2916 43.9905 45.9556C42.982 48.6195 42.4777 51.5499 42.4777 54.7467V54.7752C42.4777 59.3928 43.4228 63.3158 45.3129 66.5443C47.2031 69.7727 49.7941 72.2179 53.086 73.8797C56.3716 75.5352 60.1265 76.3629 64.3508 76.3629C66.3932 76.3629 68.3721 76.2297 70.2877 75.9633C72.1968 75.6906 73.7255 75.3132 74.8735 74.8311V79.4074C71.867 80.473 68.2865 81.0058 64.132 81.0058C60.2248 81.0058 56.6412 80.4254 53.381 79.2647C50.1208 78.104 47.2855 76.401 44.8753 74.1556C42.4587 71.9103 40.5939 69.1575 39.281 65.8973C37.9617 62.6434 37.302 58.9171 37.302 54.7181V54.6801C37.302 50.7983 37.9363 47.2527 39.2048 44.0432C40.4671 40.8401 42.2684 38.0715 44.6089 35.7373C46.9494 33.4095 49.7148 31.6145 52.9053 30.3523C56.102 29.0901 59.6223 28.459 63.466 28.459C68.3753 28.459 72.7265 29.4358 76.5195 31.3894C80.3124 33.3429 83.2904 36.1147 85.4533 39.7047C87.6162 43.3011 88.6976 47.5539 88.6976 52.4633ZM68.8605 54.8133C68.8605 52.2825 68.2707 50.2718 67.0909 48.7813C65.9111 47.2844 64.3476 46.5359 62.4004 46.5359C61.1065 46.5359 59.9965 46.8658 59.0704 47.5254C58.1381 48.1851 57.4213 49.1301 56.9202 50.3606C56.4192 51.5911 56.1686 53.0753 56.1686 54.8133V54.8418C56.1686 56.5924 56.4192 58.0893 56.9202 59.3325C57.4213 60.5757 58.1381 61.5366 59.0704 62.2153C59.9965 62.894 61.0875 63.2333 62.3433 63.2333C64.3286 63.2397 65.9111 62.4849 67.0909 60.9689C68.2707 59.453 68.8605 57.4202 68.8605 54.8704V54.8133Z",
    fill: "url(#paint3_linear_378_4836)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_4836",
    x1: 0.179352,
    y1: 0.499904,
    x2: 125.82,
    y2: 0.499904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A4DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_378_4836",
    x1: 15.381,
    y1: 95.1926,
    x2: 15.381,
    y2: 18.2927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_378_4836",
    x1: 0.179352,
    y1: 51.9528,
    x2: 125.82,
    y2: 51.9528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57CFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_378_4836",
    x1: 37.3048,
    y1: 28.4556,
    x2: 88.6949,
    y2: 28.4556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E06052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A32E43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.8639da2d3615e30fb0803d4d2b270cf1.svg";
export { ForwardRef as ReactComponent };